import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {
  private datePipe: DatePipe = new DatePipe("en-US");

  transform(value: Date | string | number | null | undefined, type: string): string | null {
    switch (type) {
      case 'formatDateTime': return this.datePipe.transform(value, "EEE MMM dd, yyyy 'at' h:mm a");
      case 'sittingsFormatDateTime': return this.datePipe.transform(value, "MMM dd, yyyy ' - ' EEEE 'at' h:mm a");
      case 'selectedTestFormatDateTime': return this.datePipe.transform(value, "EEEE, dd MMMM yyyy, h:mm a");
    }
  }

}
